// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"MappingVariablePopUp_saveButton__LJPvq"};